import {
  AccountApi,
  AdminApi,
  AuthenticationApi,
  FrontendApi,
  ImagesApi,
  LookupApi,
  MessagesApi,
  OffersApi,
  OrganisationsApi,
  PostsApi,
  ProjectsApi,
  ResourcesApi,
} from '@/api/generated'
import { Injector } from '@/config/dependency-injection'

const ApiTypes = {
  AccountApi: 'AccountApi',
  AdminApi: 'AdminApi',
  AuthenticationApi: 'AuthenticationApi',
  FrontendApi: 'FrontendApi',
  ImagesApi: 'ImagesApi',
  LookupApi: 'LookupApi',
  MessageApi: 'MessageApi',
  OffersApi: 'OffersApi',
  OffersStatisticsApi: 'OfferStatisticsApi',
  OrganisationsApi: 'OrganisationsApi',
  PostsApi: 'PostsApi',
  ProjectsApi: 'ProjectsApi',
  ResourcesApi: 'ResourcesApi',
}

const Api = {
  get Account() {
    return Injector.get<AccountApi>(ApiTypes.AccountApi)
  },

  get Admin() {
    return Injector.get<AdminApi>(ApiTypes.AdminApi)
  },

  get Authentication() {
    return Injector.get<AuthenticationApi>(ApiTypes.AuthenticationApi)
  },

  get Frontend() {
    return Injector.get<FrontendApi>(ApiTypes.FrontendApi)
  },

  get Images() {
    return Injector.get<ImagesApi>(ApiTypes.ImagesApi)
  },

  get Lookup() {
    return Injector.get<LookupApi>(ApiTypes.LookupApi)
  },

  get Messages() {
    return Injector.get<MessagesApi>(ApiTypes.MessageApi)
  },

  get Offers() {
    return Injector.get<OffersApi>(ApiTypes.OffersApi)
  },

  get Organisations() {
    return Injector.get<OrganisationsApi>(ApiTypes.OrganisationsApi)
  },

  get Posts() {
    return Injector.get<PostsApi>(ApiTypes.PostsApi)
  },

  get Projects() {
    return Injector.get<ProjectsApi>(ApiTypes.ProjectsApi)
  },

  get Resources() {
    return Injector.get<ResourcesApi>(ApiTypes.ResourcesApi)
  },
}

export { Api, ApiTypes }
